import { translate } from "../locale";

export const getDatePickerLocale = (
  datePlaceholder = translate("Seleccionar fecha"),
  timePlaceholder = translate("Seleccionar hora")
) => {
  return {
    lang: {
      locale: "es_ES",
      placeholder: datePlaceholder,
      yearFormat: "YYYY",
      monthFormat: "MMM",
      dateFormat: "DD/MM/YYYY",
      dayFormat: "DD",
      dateTimeFormat: "DD/MM/YYYY HH:mm:ss",
      monthBeforeYear: true,
      previousMonth: "Mes anterior (PageUp)",
      nextMonth: "Mes siguiente (PageDown)",
      previousYear: "Año anterior (Control + left)",
      nextYear: "Año siguiente (Control + right)",
      previousDecade: "Década anterior",
      nextDecade: "Década siguiente",
      previousCentury: "Siglo anterior",
      nextCentury: "Siglo siguiente",
    },
    timePickerLocale: {
      placeholder: timePlaceholder,
    },
  };
};
